import { gql, TypedDocumentNode } from "@apollo/client";

import { Mutation, MutationRepoCommitCreateArgs } from "types/generated";
import { PickInner } from "types/helpers";

export const COMMIT_SPACELIFT_VCS_FILES: TypedDocumentNode<
  { repoCommitCreate: PickInner<Mutation["repoCommitCreate"], "id"> },
  MutationRepoCommitCreateArgs
> = gql`
  mutation CommitSpaceliftVcsFiles($input: RepoCommitCreateInput!) {
    repoCommitCreate(input: $input) {
      id
    }
  }
`;
